<app-loading *ngIf="loading"></app-loading>
<div *ngFor="let year of calenderYears" class="year-section">
  <h2>{{ year }}</h2>
  <div class="row px-3 gap-2">
    <div
      class="col-2 month-card"
      *ngFor="let month of calendarByYear[year]"
      [ngClass]="month.status"
    >
      <div
        class="month-header d-flex justify-content-between align-items-start w-100"
      >
        <div class="month-name">{{ getMonthName(month.date) }}</div>
        <div class="status-icon">
          <app-budget-status-icon
            *ngIf="month.status !== 'future'"
            [status]="month.status"
          ></app-budget-status-icon>
        </div>
      </div>
      <div class="budget-info">
        <span matTooltip="{{ month.spend | currency : 'USD' }}"
          >Spend: {{'' | currencySymbol}}{{ getFormattedValue(month.spend) }}</span
        >
        <span matTooltip="{{ month.budget | currency : 'USD' }}"
          >Budget: {{'' | currencySymbol}}{{ getFormattedValue(month.budget) }}</span
        >
      </div>
    </div>
  </div>
</div>
